import * as z from 'zod'

export type CalculateTippingRemindersEvent = z.TypeOf<
    typeof CalculateTippingRemindersEventShape
>

export const CalculateTippingRemindersEventShape = z.object({
    type: z.literal('calculate-tipping-reminders'),
})
